import containerFuild from '../html-snippets/container-fuild';
import buttonPrimary from '../../ui-modules/button-primary/raw-html';
import css from '../tpl-css/style-section-card-multi-boxer.js';

const btnPrimary = buttonPrimary();
const btnInside = buttonPrimary({
  policy: {
    show: true,
    colPerView: 2,
    alignContent: 'left',
    items: [
      {
        icon: 'https://cdn.skyfastimg.com/6a0ee559dc2c2e000934dd37/2026/05/25/image-6a14102101d90d908a5f9ce8.png',
        text: '45-Day Money- Back Guarantee',
      },
    ],
  },
});

const html = `
<div data-use-custom-width="false" data-custom-width="1204" class="container" data-attribute="container-content" style="--custom-width: 1204px;">
  <div class="wrap-card">
    <div data-show="true" data-attribute="card-title" class="card-title">
      <h2>Dermatologist-Backed Comfort You Can Trust</h2>
      <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
    </div>
    <div class="block-swiper">
      <div class="swiper">
        <div data-attribute="list-item" class="swiper-wrapper">
          <div class="swiper-slide">
            <div data-attribute="item" data-use-custom-width-media="false" data-gutter="30" data-media-width="50" data-center-y="true" class="wrap-item" style="--gutter: 30px; --media-width: 50px;">
              <div data-attribute="media" data-media-type="image" data-order="1" class="wrap-media" style="order: 1;">
                <div data-show="true" data-attribute="wrap-img" class="wrap-img">
                  <img data-attribute="image-item" src="https://cdn.skyfastimg.com/images/2026/09/21/image-6ab0fd6863058d8c77218517.webp" alt="">
                </div>
                <div data-show="false" data-attribute="wrap-video" class="wrap-video" style="display: none;">
                  <video data-attribute="video-item" autoplay loop muted
                    src=""></video>
                </div>
              </div>
              <div data-attribute="content" data-order="2" class="wrap-content" style="order: 2;">
                
                <div data-show="true" data-attribute="title-description" class="title-description">
                  <h2>Dermatologist-Backed Comfort You Can Trust</h2>
                  <p>Lorem ipsum dolor sit amet consectetur adipisicing elit. Quisquam, quos.</p>
                </div>

                <div data-show="true" data-attribute="wrap-survey" data-color-percent="#606F99" class="wrap-survey">
                  <div data-attribute="survey-title" class="survey-title">
                    <h3>Our Boxers are Loved by Parents</h3>
                  </div>
                  <div class="list-survey-item">
                    <div data-attribute="item-survay" class="wrap-survay-item">
                      <div class="left-item">
                        <svg class="size-full" viewBox="0 0 100 100">
                          <circle class="text-gray-300" stroke-width="8" stroke="#D4DCEB" fill="transparent" cx="50"
                            cy="50" r="40"></circle>
                          <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8"
                            fill="transparent" stroke="#606F99" stroke-linecap="butt" transform="rotate(-90 50 50)"
                            stroke-dasharray="251.32741228718345" stroke-dashoffset="22.619467105846503"></circle>
                        </svg>
                        <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #606F99;"><span
                            data-attribute="percent-survay">91</span>%</div>
                      </div>
                      <div data-attribute="description-survay" class="right-item">
                        shared that our robot helped their children build patience and focus.
                      </div>
                    </div>
                    <div data-attribute="item-survay" class="wrap-survay-item">
                      <div class="left-item">
                        <svg class="size-full" viewBox="0 0 100 100">
                          <circle class="text-gray-300" stroke-width="8" stroke="#D4DCEB" fill="transparent" cx="50"
                            cy="50" r="40"></circle>
                          <circle data-attribute="percent-circle-survay" r="40" cx="50" cy="50" stroke-width="8"
                            fill="transparent" stroke="#606F99" stroke-linecap="butt" transform="rotate(-90 50 50)"
                            stroke-dasharray="251.32741228718345" stroke-dashoffset="22.619467105846503"></circle>
                        </svg>
                        <div class="wrap-percent" data-attribute="wrap-percent-survay" style="color: #606F99;"><span
                            data-attribute="percent-survay">91</span>%</div>
                      </div>
                      <div data-attribute="description-survay" class="right-item">
                        shared that our robot helped their children build patience and focus.
                      </div>
                    </div>
                  </div>
                </div>

                <div data-show="true" data-attribute="wrap-accordion" class="wrap-accordion">
                  <div data-attribute="accordion-item" class="accordion-item">
                    <div data-attribute="accordion-title" class="accordion-title">
                      <div data-attribute="accordion-title-text">Post-Surgery (e.g., Prostate)</div>
                      <div class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-chevron-down-icon lucide-chevron-down">
                          <path d="m6 9 6 6 6-6" />
                        </svg>
                      </div>
                    </div>
                    <div data-attribute="accordion-content" class="accordion-content">
                      <div data-attribute="accordion-text" class="accordion-text">
                        Perfect for recovery after prostate or bladder surgery. Our soft, breathable bamboo won't
                        irritate sensitive skin, while our 9-layer system handles post-op leaks discreetly. Recover with
                        dignity and comfort.
                      </div>
                    </div>
                  </div>
                  <div data-attribute="accordion-item" class="accordion-item">
                    <div data-attribute="accordion-title" class="accordion-title">
                      <div data-attribute="accordion-title-text">Post-Surgery (e.g., Prostate)</div>
                      <div class="accordion-icon">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                          class="lucide lucide-chevron-down-icon lucide-chevron-down">
                          <path d="m6 9 6 6 6-6" />
                        </svg>
                      </div>
                    </div>
                    <div data-attribute="accordion-content" class="accordion-content">
                      <div data-attribute="accordion-text" class="accordion-text">
                        Perfect for recovery after prostate or bladder surgery. Our soft, breathable bamboo won't
                        irritate sensitive skin, while our 9-layer system handles post-op leaks discreetly. Recover with
                        dignity and comfort.
                      </div>
                    </div>
                  </div>
                </div>

                <div data-show="true" data-attribute="wrap-item-with-icon" class="wrap-item-with-icon">
                  <div data-attribute="item-with-icon" class="wrap-item">
                    <div class="wrap-icon">
                      <img data-attribute="icon-with-icon-image"
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                        alt="">
                    </div>
                    <div class="wrap-tex-icon">
                      <div data-attribute="title-with-icon" class="title-icon">Quick Dispatch, anywhere in the world
                      </div>
                      <div data-attribute="description-with-icon" class="description-icon">Made with sustainable bamboo,
                        so you can feel good about what you're wearing.</div>
                    </div>
                  </div>
                  <div data-attribute="item-with-icon" class="wrap-item">
                    <div class="wrap-icon">
                      <img data-attribute="icon-with-icon-image"
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                        alt="">
                    </div>
                    <div class="wrap-tex-icon">
                      <div data-attribute="title-with-icon" class="title-icon">Ethically Sourced Bamboo</div>
                      <div data-attribute="description-with-icon" class="description-icon">Made with sustainable bamboo,
                        so you can feel good about what you're wearing.</div>
                    </div>
                  </div>
                  <div data-attribute="item-with-icon" class="wrap-item">
                    <div class="wrap-icon">
                      <img data-attribute="icon-with-icon-image"
                        src="https://cdn.skyfastimg.com/images/2026/03/19/image-69bb6084a8785e96398080c0.png?w=50&h=50&q=80"
                        alt="">
                    </div>
                    <div class="wrap-tex-icon">
                      <div data-attribute="title-with-icon" class="title-icon">45 Day Money Back Guarantee</div>
                      <div data-attribute="description-with-icon" class="description-icon">Made with sustainable bamboo,
                        so you can feel good about what you're wearing.</div>
                    </div>
                  </div>
                </div>

                <div data-attribute="wrap-btn-dynamic" class="wrap-btn">
                  ${btnInside}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div data-attribute="wrap-btn-dynamic-primary" class="wrap-btn">
      ${btnPrimary}
    </div>
    <div class="wrap-button-swiper">
      <div class="swiper-button-next"></div>
      <div class="swiper-button-prev"></div>
      <div class="swiper-pagination"></div>
    </div>
  </div>
</div>
`;

export default containerFuild(html, css);
